import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import type { VerificationStatus } from '@hotjar/webapp/domains/activation/tracking-code/types';

import type { TrackingSite } from '../utils';
import { extractSiteGroupingProps } from '../utils';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export const trackingCodeVerificationAttempt = (
  site: TrackingSite,
  status: VerificationStatus,
): void => {
  if (site) {
    const data = { status, ...extractSiteGroupingProps(site) };
    Segment.track('Tracking Code Verification Attempted', data);
  }
};
